export const BASE_URL = '/v3/project-owners';

export const PROJECT_OWNERS_STATUS = {
  REGISTERED: 'registered',
  INVITED: 'invited',
  REGISTERED_DISABLED: 'disabled_registered',
  INVITED_DISABLED: 'disabled_invited',
} as const;
